export type HomeProductDetail = {
	productId: number;
	/** Código con el que se carga el producto en la ruta /p/:id y en Cobis. */
	productCode: string;
	subProductId: number;
	viewName: string;
	productName: string;
	/** Nombre comercial del producto, el que se le muestra al socio. */
	productDescription: string;
	/** Tasa anual con la que se simula el crédito. */
	rate: number;
	/** CAT promedio ponderado que se muestra en las pantallas del simulador. */
	cat: number;
	/**
	 * Rango de montos del simulador del home. En las pantallas de oferta
	 * preautorizada el máximo lo define el monto autorizado al socio.
	 */
	minAmount: number;
	maxAmount: number;
	/**
	 * Tipo de amortización con la que se simula el crédito. No aplica para
	 * productos que no pasan por cmv-credit-simulator (p. ej. TDC).
	 */
	reimbursementType?: 'FRANCESA' | 'ALEMANA';
};

const products: Array<HomeProductDetail> = [
	{
		productId: 1,
		 productCode: 'ACTICASH',
		subProductId: 245,
		viewName: 'Home Activaca$h',
		productName: 'Crédito Digital',
		productDescription: 'Activaca$h',
		rate: 97.08,
		cat: 78.0,
		minAmount: 5000,
		maxAmount: 80000,
		reimbursementType: 'FRANCESA',
	},
	{
		productId: 2,
		productCode: 'SPD',
		subProductId: 245,
		viewName: 'Home Socio Puntual Digital',
		productName: 'Socio Puntual Digital',
		productDescription: 'Socio Puntual Digital',
		rate: 26.4,
		cat: 28.04,
		minAmount: 5000,
		maxAmount: 100000,
		reimbursementType: 'ALEMANA',
	},
	{
		productId: 3,
		productCode: 'TDC',
		subProductId: 270,
		viewName: 'Home Tarjeta De Crédito',
		productName: 'Tarjeta de Crédito CMV',
		productDescription: 'Tarjeta de Crédito CMV',
		rate: 0,
		cat: 92.1,
		minAmount: 5000,
		maxAmount: 80000,
	},
];

/** Producto que se usa cuando la ruta no trae un código conocido. */
export const DEFAULT_PRODUCT_CODE = 'ACTICASH';

export const getHomeProductDetailsByProduct = (
	productId: number
): HomeProductDetail => {
	return products.find(homeProduct => homeProduct.productId === productId);
};

export const getHomeProductDetailsByCode = (
	productCode: string
): HomeProductDetail => {
	if (!productCode) {
		return undefined;
	}
	const normalizedProductCode = productCode.trim().toUpperCase();
	return products.find(
		homeProduct => homeProduct.productCode === normalizedProductCode
	);
};

/**
 * Id del producto que corresponde a un código; si el código no está en el
 * catálogo se regresa el del producto por defecto.
 */
export const getProductIdByCode = (productCode: string): number => {
	const product =
		getHomeProductDetailsByCode(productCode) ??
		getHomeProductDetailsByCode(DEFAULT_PRODUCT_CODE);
	return product.productId;
};
